import {ENV_BASE_URL_HOSTNAME} from './EnvironmentConfig';
import {Environment, ENV_TYPES} from './EnvironmentTypes';

export function getEnviromentType(): ENV_TYPES {
  if (process.env.NODE_ENV === 'development') {
    return ENV_TYPES.LOCAL;
  }
  const hostName: string = window.location.hostname;
  if (hostName.startsWith(ENV_BASE_URL_HOSTNAME[ENV_TYPES.DEV])) {
    return ENV_TYPES.DEV;
  } else if (hostName.startsWith(ENV_BASE_URL_HOSTNAME[ENV_TYPES.STAGING])) {
    return ENV_TYPES.STAGING;
  } else if (hostName.startsWith(ENV_BASE_URL_HOSTNAME[ENV_TYPES.TRAINING])) {
    return ENV_TYPES.TRAINING;
  } else if (hostName.startsWith(ENV_BASE_URL_HOSTNAME[ENV_TYPES.INT])) {
    return ENV_TYPES.INT;
  } else {
    return ENV_TYPES.PROD;
  }
}

export const getEnvironment = (): Environment => {
  const env = getEnviromentType();
  return new Environment(env);
};

export const getBaseUrl = (): string => {
  const envObj = getEnvironment();
  return envObj.baseUrl;
};

export const getAgentUrl = (): string => {
  const envObj = getEnvironment();
  return envObj.baseUrl + 'SalesPortal/';
};

export const getSecurePolicyPdf = (): string => {
  const envObj = getEnvironment();
  return envObj.baseUrl + 'edocs/view/security-policy.pdf';
};

export const getPrivatePolicyPdf = (): string => {
  const envObj = getEnvironment();
  return envObj.baseUrl + 'edocs/view/privacy-policy.pdf';
};

export const getQuoteUrl = (): string => {
  const envObj = getEnvironment();
  return envObj.baseUrl + 'quoting/';
};

export const getCSSUrl = (): string => {
  const envObj = getEnvironment();
  return envObj.baseUrl + 'ClientSelfService/';
};

export const getRegistrationUrl = (): string => {
  const envObj = getEnvironment();
  return envObj.baseUrl + 'ClientSelfService/signUpPage';
};

export const getRetrieveQuoteUrl = (): string => {
  const envObj = getEnvironment();
  return envObj.baseUrl + 'PublicQuoting/main/landingPage';
};
